import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CatalogoService {

  constructor() {
  }

  catalogoTipoLectura() {
    return [
      {clave: '1', valor: 'Tarjeta'},
      {clave: '2', valor: 'Cédula'}
    ];
  }

  getSexo() {
    return [
      {"id": "Femenino", "descripcion": "Femenino"},
      {"id": "Masculino", "descripcion": "Masculino"},
    ];
  }

  getEstadoCivil() {
    return [
      {"id": "DIV", "descripcion": "DIVORCIAD(A)"},
      {"id": "UNL", "descripcion": "UNION LIBRE"},
      {"id": "VIU", "descripcion": "VIUD(A)"},
      {"id": "CAS", "descripcion": "CASAD(A)"},
      {"id": "SOL", "descripcion": "SOLTER(A)"},
      {"id": "N/D", "descripcion": "NO DEFINIDO"}
    ];
  }

  getRegion() {
    return [
      {"id": "COSTA", "descripcion": "COSTA"},
      {"id": "SIERRA", "descripcion": "SIERRA"},
    ];
  }

  getTipoColaborador() {
    return [
      {"id": "COLABORADOR", "descripcion": "COLABORADOR"},
      {"id": "CONTRATISTA", "descripcion": "CONTRATISTA/PROVEEDOR"},
      {"id": "VISITANTE", "descripcion": "VISITANTE"},
    ];
  }

  rolesDotacion() {
    return {
      DOTACIONADMIN: "DOTACION-ADMIN",
      DOTACIONENTREGA: "DOTACION-ENTREGA"
    }
  }

  authDotacion() {
    return {
      ROLEADMINDOTACION: "ROLE_ADMIN_DOTACION",
      ROLEPUNTOENTREGADOTACION: "ROLE_PUNTO_ENTREGA_DOTACION"
    }
  }

  catalogoTipo() {
    return [
      {clave: 'Principal', valor: 'Principal'},
      {clave: 'General', valor: 'General'}
    ]
  }

  catalogoBanderaUser() {
    return {
      Principal: "Principal",
      General: "General"
    }
  }

  getCodEmpreFabril() {
    return {
      codEmpresa: "FABR",
      descripcion: "LA FABRIL S.A.",
      grupoFabril: 1
    };
  }

  catalogoAccesoIESS() {
    return [
      {clave: 'Activo', valor: 'Activo'},
      {clave: 'Inactivo', valor: 'Inactivo'}
    ];
  }

}
